/* global axios */
import ApiClient from './ApiClient';

class BridgeProxyAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getConnectionStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/bridge/status`);
  }

  reconnect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/bridge/reconnect`);
  }

  getQrStreamUrl(inboxId) {
    return `${this.url}/${inboxId}/bridge/qr`;
  }

  getQrData(inboxId) {
    return axios.get(`${this.url}/${inboxId}/bridge/qr`);
  }
}

export default new BridgeProxyAPI();
